<template>

  <div class="open-hours">
    <p>Open Monday - Friday: 11am to 7pm</p>
    <p>Saturday: 11am to 6pm</p>
  </div>


  <div class="footer-grid-container">
    <div class="footer-left-text">
      <p>121 Congressional Ln. Suite 105</p>
      <p>Rockville, MD 20852</p>
      <p>(240) 760-1112</p>
    </div>

    <div class="footer-right-text">
      <p>Copy Right reserved </p>
      <p>for K-Bap House</p>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'HomeFooter'
  }

</script>
  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .open-hours {
    text-align: center;
    font-size: 1.3rem;
    font-weight: bold;
    font-style: italic;
    line-height: 0.5rem;
    width: 100%;
    height: 8rem;
    margin-top: 4rem;
    color: rgb(63, 3, 3);
  }


  .footer-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: -4vw;
    background-color:  rgb(188,143,143);
  }

 .footer-left-text {
    text-align: left;
    justify-content: left;
    color: white;
    font-style: optima;
    line-height: 0.3rem;
    font-size: 1.2rem;
    font-weight: bold;;
    margin-top: 0.5vw;
    margin-left: 1vw;
  }

 .footer-right-text {
    text-align: right;
    justify-content: right;
    color: white;
    font-style: optima;
    font-weight: bold;
    font-size: 1rem;
    line-height: 0.1rem;
    margin-top: 0.3vw;
    margin-right: 1vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .open-hours {
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    font-style: italic;
    line-height: 0.5rem;
    width: 100%;
    height: auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: rgb(63, 3, 3);
  }
 .footer-left-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    height: auto;
    font-size: 1.2rem;
    line-height: 0.3rem;
    font-weight: bold;
  }

 .footer-right-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1rem;
    line-height: 0.3rem;
    margin-top: 2rem;
  }

}
  
</style>